module.exports = __webpack_public_path__ + "img/icon-new-diary.31d0aaf7.svg";